import React, {useRef, useState} from 'react';
import {useDispatch} from 'react-redux';
import {Form, Formik} from 'formik';
import {useIntl} from 'react-intl';
import classNames from 'classnames';
import CommonPopup from '../../../_common/components/CommonPopup';
import {DataItem} from '../../../_common/components/DataItem';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import {checkEmailIsValid} from '../../../_common/utils/checkEmailIsValid';
import {updateCustomerData} from '../../_redux/customersActions';
import DataItemCheckbox from "../../../_common/components/DataItemCheckbox";

export function UpdateCustomerDataPopup(cellContent) {
  const {formatMessage} = useIntl();
  const dispatch = useDispatch();
  const formikRef = useRef();
  const [disabledButton, setDisabledButton] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const prefix = 'customers-updateCustomerData-popup';
  const fullHeader = [
    formatMessage({id: `${prefix}-header`, defaultMessage: 'Customer name'}),
    cellContent?.customerID
  ].filter(Boolean).join(' - ');

  const validate = (values) => {
    let errors = {};
    const {email} = values;
    setEmailError(false);
    if (!checkEmailIsValid(email)) {
      errors.email = 'Invalid email address';
      setEmailError(true);
    }

    setDisabledButton(Object.keys(errors).length > 0);

    return errors;
  };

  const commonInputProps = {inputContainerStyle: 'w-75 mx-auto mb-4', topLabelStyle: 'pl-4'};

  const fieldsArray = [
    {
      fieldId: 'firstName',
      label: formatMessage({id: `${prefix}-label-firstName`, defaultMessage: 'First name'}),
      mandatory: false
    },
    {
      fieldId: 'lastName',
      label: formatMessage({id: `${prefix}-label-lastName`, defaultMessage: 'Last name'}),
      mandatory: false
    },
    {
      fieldId: 'idNumber',
      label: formatMessage({id: `${prefix}-label-id`, defaultMessage: 'ID'}),
      mandatory: false,
      disabled: true
    },
    {
      fieldId: 'city',
      label: formatMessage({id: `${prefix}-label-city`, defaultMessage: 'City'}),
      mandatory: false
    },
    {
      fieldId: 'street',
      label: formatMessage({id: `${prefix}-label-address`, defaultMessage: 'Address'}),
      mandatory: false
    },
    {
      fieldId: 'phoneNumbers',
      label: formatMessage({id: `${prefix}-label-phone`, defaultMessage: 'Phone'}),
      mandatory: false,
    },
    {
      fieldId: 'email',
      label: formatMessage({id: `${prefix}-label-email`, defaultMessage: 'Email'}),
      mandatory: true
    },
  ];

  const getFieldLabel = (label, mandatory = true) => {
    return (
      <div className={'position-relative font-weight-bolder'}>
        {mandatory && <span className={'mandatoryMark'}>*</span>}
        <span className={'custom-brand-color'}>{label}</span>
      </div>
    );
  };
  const getField = (item) => {
    const {fieldId, label, mandatory, disabled} = item;
    return (
      <div className={'position-relative'}>
        <DataItem
          dir={fieldId === 'phoneNumbers' ? 'ltr' : 'rtl'}
          fieldId={fieldId}
          label={getFieldLabel(label, mandatory)}
          disabled={disabled}
          customInputStyle={fieldId === 'phoneNumbers'
            ? 'custom-data-item text-left'
            : 'custom-data-item'
          }
          {...commonInputProps}
        />
        {(fieldId === 'email' && emailError) && (
          <div
            className={'invalid-email-message invalid-email-message-customers'}
          >
            {formatMessage({id: 'invalid-email-message', defaultMessage: 'Invalid email'})}
          </div>
        )}
      </div>
    );
  };

  const getContent = () => {
    return (
      <Formik
        initialValues={{
          firstName: cellContent?.firstName || '',
          lastName: cellContent?.lastName || '',
          idNumber: cellContent?.idNumber || '',
          city: cellContent?.address?.primary?.city || '',
          street: cellContent?.address?.primary?.street || '',
          phoneNumbers: cellContent?.phoneNumbers && cellContent?.phoneNumbers.length > 0
            ? cellContent?.phoneNumbers?.filter(Boolean).join(', ')
            : '',
          email: cellContent?.email || '',
          allowInvoiceDeal: cellContent?.allowInvoiceDeal,
        }}
        onSubmit={() => null}
        enableReinitialize={true}
        validate={validate}
        validateOnMount={true}
        innerRef={formikRef}
      >
        <Form className={'mb-12'}>
          {fieldsArray.map(getField)}
          <DataItemCheckbox
            fieldName={'allowInvoiceDeal'}
            label={formatMessage({id: `${prefix}-label-allowInvoiceDeal`, defaultMessage: 'Allow invoice deal'})}
            containerClassname={'d-flex justify-content-center w-75 mx-auto my-6'}
            labelClassname={'mr-4'}
          />
        </Form>
      </Formik>
    );
  };

  return (
    <CommonPopup
      icon={<img src={toAbsoluteUrl('/media/svg/WriteBrandColor.svg')} alt="add-commission"/>}
      buttonOpenPopupClassName={classNames('btn btn-icon btn-light btn-sm mx-3 custom-action-button', {
        [`cursor-default custom-disabled-button`]: !cellContent?.isActual
      })}
      header={fullHeader}
      content={() => getContent()}
      onConfirm={() => {
        dispatch(updateCustomerData(`${cellContent?.customerID}`, formikRef.current?.values));
      }}
      disabled={!cellContent?.isActual}
      buttonLabelConfirm={formatMessage({id: 'customers-updateCustomerData-popup-label-save', defaultMessage: 'Save'})}
      disabledConfirmButton={disabledButton}
      buttonTooltip={formatMessage({id: 'customers-column-updateCustomerData', defaultMessage: 'Edit customer data'})}
    />
  );
}